module.exports = __webpack_public_path__ + "img/m-hd.5cdc413e.webp";